<div class="modal-body m-0 m-lg-3">
  <div class="mb-4">
    <h3 translate>{{request.jobName}}</h3>
  </div>

  <span class="mb-4" translate="Dialog.PleaseSelectYourCertificate"></span>

  <div class="mt-4 w-100 certificateList overflow-y-auto" [(ngModel)]="selectedCertificate">
    <ul class="d-flex list-group mb-4" *ngFor="let cert of certificates; let i = index;">
      <li class="list-group-item subheader d-flex justify-content-between align-items-center">
        <div class="col-12 justify-content-between align-items-center">
          <input class="mt-1 me-2 form-check-input radio" name="selectedCertificate" id="{{cert.id}}" type="radio" [value]="cert.id" (change)="updateCertificate(cert.id)">
          <label class="form-check-label subheaderlist" for="{{cert.id}}"><strong>{{cert.subject["CN"]}}</strong></label>
        </div>
      </li>
      <li class="list-group-item certificate d-flex justify-content-between align-items-center">
        <div class="col-3 col-md-4 text-truncate">
          <strong translate="Request.View.Certificates.Issuer"></strong>
        </div>
        <div class="col-9 col-md-8 text-truncate">
          <span>{{cert.issuer["CN"]}}</span>
        </div>
      </li>
      <li class="list-group-item certificate d-flex justify-content-between align-items-center">
        <div class="col-3 col-md-4 text-truncate">
          <strong translate="Request.View.Certificates.IssueDate"></strong>
        </div>
        <div class="col-9 col-md-8 text-truncate">
          <span>{{cert.validFrom | readableDateComparedWithToday}}</span>
        </div>
      </li>
      <li class="list-group-item certificate d-flex justify-content-between align-items-center">
        <div class="col-3 col-md-4 text-truncate">
          <strong translate="Request.View.Certificates.ExpirationDate"></strong>
        </div>
        <div class="col-9 col-md-8 text-truncate">
          <span>{{cert.validUntil | readableDateComparedWithToday}}</span>
        </div>
      </li>
      <li class="list-group-item certificate d-flex justify-content-between align-items-center" *ngIf="cert.subject['T']">
        <div class="col-3 col-md-4 text-truncate">
          <strong translate="Request.View.Certificates.Title"></strong>
        </div>
        <div class="col-9 col-md-8 text-truncate">
          <span>{{cert.subject["T"]}}</span>
        </div>
      </li>
    </ul>
  </div>
  
  <p *ngIf="certificates.length==0" translate="Request.View.Certificates.NoCertificates"></p>

  <div class="mt-4 d-table w-100">
    <span class="float-start">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="back();" translate="Button.Back"></button>
    </span>
    <span class="float-end">
      <button *ngIf="certificates.length>0" type="button" class="btn btn-sm btn-success ms-1 order-1 float-end" (click)="selectCertificate();" translate="Button.Next"></button>
    </span>
  </div>
</div>
